import { api } from '@/lib/api'
import type {
  BillingSubscriptionResponse,
  BillingUsageResponse,
  CheckoutSessionResponse,
  PaidPlanId,
  ProfileTier,
} from './types'

export const subscriptionsApi = {
  getTier: () => api.get<ProfileTier>('/api/profile'),
  getSubscription: () => api.get<BillingSubscriptionResponse>('/api/billing/subscription'),
  getUsage: () => api.get<BillingUsageResponse>('/api/billing/usage'),
  createCheckoutSession: (planId: PaidPlanId) =>
    api.post<CheckoutSessionResponse>('/api/subscriptions/create-checkout-session', { planId }),
  cancelSubscription: () =>
    api.post<BillingSubscriptionResponse>('/api/billing/subscription/cancel', {}),
  resumeSubscription: () =>
    api.post<BillingSubscriptionResponse>('/api/billing/subscription/resume', {}),
}
